import DynamicMap from '@ui/Map/Dynamic/component'
import Modal from '@ui/Modal/component'
import type { ModalType } from '@ui/Modal/component'

export default function (): ModalType | null {
  const markerEl = document.getElementById('product-full-map-marker')

  if (!markerEl) {
    return null
  }

  let isMapInitialized = false

  const modal = Modal('#product-full-map-modal', {
    onOpen: function () {
      let map = null

      if (!isMapInitialized) {
        map = new DynamicMap(
          '#product-full-map',
          {
            closeButton: true,
            onClose: function () {
              modal.close()
            },
          },
          [
            {
              latitude: parseFloat(markerEl.getAttribute('data-latitude') as string),
              longitude: parseFloat(markerEl.getAttribute('data-longitude') as string),
            },
          ]
        )

        isMapInitialized = true
      }

      return map
    },
  })

  return modal
}
